export default __webpack_public_path__ + "2d562d8b4b014131e31d015ba52e6bd1.png";